import { render, staticRenderFns } from "./selfConsolidation.vue?vue&type=template&id=68136d65&scoped=true&"
import script from "./selfConsolidation.vue?vue&type=script&lang=js&"
export * from "./selfConsolidation.vue?vue&type=script&lang=js&"
import style0 from "./selfConsolidation.vue?vue&type=style&index=0&id=68136d65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68136d65",
  null
  
)

export default component.exports